/* eslint-disable class-methods-use-this */
import DataConverter from './DataConverter.model';

export interface IProductCategoryApiModel {
  id: string;
  name: string;
}

export interface IProductCategory {
  id: string;
  name: string;
}

class ProductCategoryConverter extends DataConverter<
  IProductCategoryApiModel,
  IProductCategory
> {
  fromApiModel(model: IProductCategoryApiModel): IProductCategory {
    return model;
  }
}

export default new ProductCategoryConverter();
